"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallet = void 0;
var Buffer = require('buffer/').Buffer;
var shamirs_secret_sharing_1 = __importDefault(require("@consento/shamirs-secret-sharing"));
var bs58_1 = __importDefault(require("bs58"));
var __1 = require("..");
var utils_1 = require("./utils");
var Wallet = /** @class */ (function () {
    function Wallet(_a) {
        var mnemonic = _a.mnemonic, rootKey = _a.rootKey, identity = _a.identity;
        this.mnemonic = mnemonic;
        this.rootKey = rootKey;
        this.identity = identity;
    }
    Wallet.create = function (_a) {
        var mnemonic = _a.mnemonic;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        mnemonic = mnemonic || bs58_1.default.encode(sodium.randombytes_buf(1024));
                        return [2 /*return*/, Wallet.createWalletFromMnemonic(mnemonic)];
                }
            });
        });
    };
    Wallet.createWalletFromMnemonic = function (mnemonic) {
        return __awaiter(this, void 0, void 0, function () {
            var sodium, rootKey, identity, wallet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()
                        // Derive root key from mnemonic
                    ];
                    case 1:
                        sodium = _a.sent();
                        rootKey = sodium.crypto_kdf_derive_from_key(64, (2 ^ 64) - 1, 'ROOT_KEY', sodium.crypto_generichash(32, Buffer.from(mnemonic)));
                        identity = sodium.crypto_generichash(32, sodium.crypto_generichash(32, rootKey));
                        wallet = new Wallet({
                            identity: bs58_1.default.encode(identity),
                            mnemonic: mnemonic,
                            rootKey: rootKey,
                        });
                        return [2 /*return*/, wallet];
                }
            });
        });
    };
    Wallet.prototype.deriveAddress = function (_a) {
        var path = _a.path, type = _a.type;
        return __awaiter(this, void 0, void 0, function () {
            var sodium, salt, ctx, derivedKey, keyPair, identity, address;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        salt = sodium.crypto_generichash(32, sodium.crypto_generichash(64, path));
                        ctx = bs58_1.default.encode(salt).substr(0, 8);
                        derivedKey = sodium.crypto_kdf_derive_from_key(32, 1, ctx, sodium.crypto_generichash(32, Buffer.concat([salt, this.rootKey])));
                        if (type === __1.AddressType.BOX) {
                            keyPair = sodium.crypto_box_seed_keypair(derivedKey);
                        }
                        else if (type === __1.AddressType.SIGN) {
                            keyPair = sodium.crypto_sign_seed_keypair(derivedKey);
                        }
                        else {
                            keyPair = sodium.crypto_kx_seed_keypair(derivedKey);
                        }
                        identity = sodium.crypto_generichash(32, sodium.crypto_generichash(32, keyPair.publicKey));
                        address = new __1.Address({
                            identity: bs58_1.default.encode(identity),
                            key: derivedKey,
                            publicKey: keyPair.publicKey,
                            privateKey: keyPair.privateKey,
                            type: type,
                            path: path,
                            wallet: this,
                        });
                        return [2 /*return*/, address];
                }
            });
        });
    };
    Wallet.prototype.backup = function (_a) {
        var numShares = _a.numShares, threshold = _a.threshold;
        var _shares = shamirs_secret_sharing_1.default.split(this.mnemonic, { shares: numShares, threshold: threshold });
        var shares = _shares.map(function (share) {
            return Buffer.from(share).toString('base64');
        });
        return shares;
    };
    Wallet.restore = function () {
        var shares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            shares[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var _shares, mnemonic;
            return __generator(this, function (_a) {
                _shares = shares.map(function (share) {
                    return Buffer.from(share, 'base64').toString('hex');
                });
                try {
                    mnemonic = shamirs_secret_sharing_1.default.combine(_shares).toString('utf-8');
                    return [2 /*return*/, Wallet.createWalletFromMnemonic(mnemonic)];
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    };
    return Wallet;
}());
exports.Wallet = Wallet;
